import { Tab as MuiTab, withStyles } from '@material-ui/core';

import { colors, fonts } from '../styles';

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const PanelTab = withStyles({
  root: {
    textTransform: 'none',
    transitionDuration: '.3s',
    transitionTimingFunction: 'ease-in-out',
    transitionProperty: 'background-color, box-shadow',
    letterSpacing: 'normal',
    opacity: 1,

    fontSize: fonts.size.small,
    fontWeight: fonts.weight.regular,
    color: colors.gray.dark,

    width: '210px',
    borderBottom: `solid 3px ${colors.gray.light}`,

    '&:hover': {
      fontWeight: fonts.weight.bold,
    },
  },
  selected: {
    color: colors.primary.default,
    fontWeight: fonts.weight.bold,
  },
  wrapper: {
    display: '',
  },
})(MuiTab);
